import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './marketing.css';

export default function Thanks() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) { clearInterval(timer); navigate('/'); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="mkt-root">
      {/* Nav */}
      <nav className="mkt-nav">
        <a href="/" className="mkt-nav-brand" onClick={e => { e.preventDefault(); navigate('/'); }}>
          <img src="/GANTIMA-Logo.png" alt="Gantima" className="mkt-nav-logo-left-img" />
          <span className="mkt-nav-brand-tag">SOFTWARE AUTOMATION</span>
        </a>
        
        <div className="mkt-nav-actions">
          <button className="mkt-btn mkt-btn-primary mkt-btn-glow" onClick={() => navigate('/')}>Back to Home</button>
        </div>
      </nav>

      {/* Thank You Content */}
      <section style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '120px 5% 80px',
        background: '#020817',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Background orbs */}
        <div style={{
          position: 'absolute', width: '500px', height: '500px', borderRadius: '50%',
          background: 'rgba(79,142,247,0.1)', filter: 'blur(100px)',
          top: '-100px', right: '-100px', pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', width: '400px', height: '400px', borderRadius: '50%',
          background: 'rgba(124,58,237,0.08)', filter: 'blur(80px)',
          bottom: '-80px', left: '-60px', pointerEvents: 'none',
        }} />

        <div style={{
          position: 'relative', zIndex: 1, textAlign: 'center',
          maxWidth: '640px', width: '100%',
        }}>
          {/* Success icon */}
          <div style={{
            width: '100px', height: '100px', borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(16,185,129,0.15), rgba(16,185,129,0.05))',
            border: '2px solid rgba(16,185,129,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 32px', fontSize: '3rem',
            boxShadow: '0 0 40px rgba(16,185,129,0.15)',
          }}>
            ✅
          </div>

          <div className="mkt-pill-green mkt-pill" style={{ marginBottom: '20px' }}>
            SUBMISSION RECEIVED
          </div>

          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 900,
            color: '#f1f5f9', lineHeight: 1.15, marginBottom: '20px',
          }}>
            Thank You for <span className="mkt-gradient-text">Reaching Out!</span>
          </h1>

          <p style={{
            fontSize: '1.1rem', color: '#94a3b8', lineHeight: 1.75,
            maxWidth: '500px', margin: '0 auto 36px',
          }}>
            We've received your consultation request. Our AI automation team will review your needs and get back to you within <strong style={{ color: '#4f8ef7' }}>24 hours</strong>.
          </p>

          {/* What happens next card */}
          <div style={{
            background: 'rgba(10,22,40,0.85)',
            border: '1px solid rgba(79,142,247,0.2)',
            borderRadius: '20px', padding: '32px',
            textAlign: 'left', marginBottom: '36px',
            boxShadow: '0 0 40px rgba(79,142,247,0.08)',
          }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#f1f5f9', marginBottom: '20px' }}>
              What Happens Next?
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {[
                { icon: '📧', step: '1', text: 'You\'ll receive a confirmation email shortly' },
                { icon: '🔍', step: '2', text: 'Our team reviews your automation needs' },
                { icon: '📞', step: '3', text: 'We\'ll schedule a free strategy call within 24 hours' },
                { icon: '🚀', step: '4', text: 'Get a custom automation roadmap & ROI estimate' },
              ].map((item, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: '14px',
                  padding: '12px 16px',
                  background: 'rgba(15,32,64,0.6)',
                  border: '1px solid rgba(79,142,247,0.08)',
                  borderRadius: '12px',
                }}>
                  <div style={{
                    width: '36px', height: '36px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, #4f8ef7, #7c3aed)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '.8rem', fontWeight: 800, color: '#fff', flexShrink: 0,
                  }}>
                    {item.step}
                  </div>
                  <span style={{ fontSize: '.9rem', color: '#e2e8f0', fontWeight: 500 }}>
                    {item.icon} {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA buttons */}
          <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
            <button className="mkt-btn mkt-btn-primary mkt-btn-lg mkt-btn-glow" onClick={() => navigate('/')}>
              ← Back to Homepage
            </button>
          </div>

          <p style={{ fontSize: '.82rem', color: '#475569' }}>
            Redirecting to homepage in {countdown} seconds...
          </p>
        </div>
      </section>

      {/* Minimal footer */}
      <footer style={{
        background: '#010510', borderTop: '1px solid rgba(79,142,247,0.1)',
        padding: '24px 5%', textAlign: 'center',
      }}>
        <p style={{ fontSize: '.8rem', color: '#334155' }}>
          © {new Date().getFullYear()} Gantima Software. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
